import { AGENCY_INCLUDED_SEATS } from "features/subscriptions/constants";
import { useManageSubscription } from "features/subscriptions/context/ManageSubscriptionContext";
import useAgencyPurchaseMinSeats from "features/subscriptions/hooks/useAgencyPurchaseMinSeats";

export default function useMinSeatQuantity() {
  const { subscriptionType, hasActiveSubscription, rentalOrderSubscription } =
    useManageSubscription();

  const isAgencyPurchase =
    subscriptionType === "agency" && !hasActiveSubscription;

  const {
    minSeats: agencyPurchaseMinSeats,
    totalActiveOutreachSeats,
    outreachSeatBreakdown,
  } = useAgencyPurchaseMinSeats(isAgencyPurchase);

  let minSeatQuantity = hasActiveSubscription ? 0 : 1;
  if (subscriptionType === "agency") {
    minSeatQuantity = isAgencyPurchase
      ? agencyPurchaseMinSeats
      : AGENCY_INCLUDED_SEATS;
  } else if (subscriptionType === "rental") {
    minSeatQuantity = rentalOrderSubscription ? 0 : 1;
  }

  return {
    minSeatQuantity,
    isAgencyPurchase,
    agencyPurchaseMinSeats,
    totalActiveOutreachSeats,
    outreachSeatBreakdown,
  };
}
